import { List } from "antd";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Localize from "../../utils/string";
import { Content } from "antd/lib/layout/layout";
import Releases from "../../components/releases";
import OurServices from "../../components/ourServices";
import CarouselItems from "../../components/CarouselItems";
import OurServicesTop from "../../components/ourServicesTop";
import ReleasesHeading from "../../components/releasesHeading";
import {
  getBanner,
  getHomePageProducts,
} from "../../store/products/productsAsyncActions";
import { OurServices1, OurServices2, OurServices3 } from "../../assets/images";
import Loadingtext from "../../components/loading";
import { setLoading } from "../../store/common/commonActions";
import { imageUrl } from "../../utils/functions";
import NoRecordFound from "../../components/NoRecordFound";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import { Helmet } from 'react-helmet';

const ourServicesLabels = [
  {
    id: 1,
    image: OurServices1,
    title: "Physical Distribution",
    desc: "One of the world’s leading distributors of music on vinyl covering 7”, 12” and albums, from heritage to cutting edge. Our long-standing relationships with all major UK and international stockists, alongside independent stores across the world, mean that you are in safe hands when it comes to wide-ranging global coverage. We help labels with the reach and visibility to grow their fanbase.",
    button: "Find Out More",
    key: "physical-distribution",
  },
  {
    id: 2,
    image: OurServices3,
    title: "Digital Distribution",
    desc: "We cover all major Digital Service Providers, music stores and social media platforms including Spotify, Traxsource, Beatport, Juno Download, Apple Music, Facebook / Instagram, YouTube, Shazam and many more alongside working to secure features, playlists to get the maximum coverage for our labels.",
    button: "Find Out More",
    key: "digital-distribution",
  },
  {
    id: 3,
    image: OurServices2,
    title: "Label Services",
    desc: "Distilling over two decades worth of experience in selling and distributing music, we utilise what we’ve learnt over the years to benefit our labels. Comprehensive knowledge of manufacture, marketing, accounting, royalties, strategy, rights management, data and analytics, building your fan base, licensing and beyond.",
    button: "Find Out More",
  },
];

const HomePage = () => {
  const dispatch = useDispatch();
  const [MoreData, setMoreData] = useState(false);
  const [bannerData, setBannerData] = useState([] as any);
  const [bannerMarqueData, setBannerMarqueData] = useState<string>('');
  const [ProductsData, setProductsData] = useState([] as any);
  const loginResp = useSelector((state: any) => state.user.userSession);
  const Loading = useSelector((state: any) => state.common.loading);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const [activeSlide, setActiveSlide] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust the threshold according to your needs
    };

    // Listen to window resize events
    window.addEventListener("resize", handleResize);

    // Call the handler once to set the initial value
    handleResize();

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const response: any = await dispatch(getBanner());
      if(response && response.BannerTicketText){
        setBannerMarqueData(response.BannerTicketText);
      }else{
        setBannerMarqueData('');
      }
      if (response && response?.data) {
        response?.data?.sort(() => Math.random() - 0.5);
        const index = response?.data.findIndex((option:any) => option.priorityBanner)
        if(index !== -1 && index > 0){
          const bannerObj = response?.data.find((option:any) => option.priorityBanner)
          response?.data.splice(index, 1);
          response?.data?.unshift(bannerObj)
        }
        setBannerData(response?.data);
      }else{
        setBannerData([]);
      }
    };
    // document.title = "Home - Prime Direct Distribution";
    fetchData();
    dispatch(setLoading(true));
  }, []);
  const changeBgImage = (slide: number) => {
   
    setActiveSlide(slide);
  };
  const initialFunction: any = useCallback(async () => {
    const cId = loginResp?.userId ?? 0;
    const response: any = await dispatch(
      getHomePageProducts(`?startIndex=1&pageSize=30&customerId=${cId}`, false)
    );
    if (response) {
      setProductsData(response);
    }
  }, [dispatch]);

  useEffect(() => {
    initialFunction();
    // document.title = "Home - Prime Direct Distribution";
  }, [initialFunction]);
  useEffect(() => {
    scrollToTop();
  }, [Loading]);
  const scrollToTop = () => {
    const top = document.getElementById("top") as HTMLElement;

    setTimeout(() => {
      if (isMobile) {
        top.scrollIntoView();
      } else window.scrollTo(0, 0);
    }, 200);
  };

 
//  // Set this to the total number of slides you have
//   useEffect(() => {
//     const interval = setTimeout(() => {
//       if (bannerData?.length > 0) {
      
//         if (activeSlide < bannerData?.length - 1) {
         
//           setActiveSlide((prevSlide) => prevSlide + 1);
//         } else {
        
//           setActiveSlide(0);
//         }
//       }
//     }, 5000); // Adjust interval as needed
    
//     return() =>clearTimeout(interval); // Cleanup on component unmount
//   }, [activeSlide, bannerData]);
  return (
    <div id="top">
    <Helmet>
        <title>{'Prime Direct Distribution: Home'}</title>
        <meta name="description" content={'Worldwide physical and digital distribution. From music lovers, to music lovers. '} />
        <meta property="og:title" content={'Prime Direct Distribution: Home'} />
        <meta property="og:description" content={'Worldwide physical and digital distribution. From music lovers, to music lovers. '} />
      </Helmet>
      {Loading ? (
        <Loadingtext />
      ) : (
        <div className="homepage">
          <div className="carosel-detail">
            <div className="carosel-overlay"></div>
            {bannerData?.length > 0 && (
              <Swiper
              slidesPerView={1}
              loop={true}
            
              navigation={true}
              modules={[Navigation,Autoplay]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
            >
              {bannerData?.map((item: any, index: number) => {
                const { imageUrl, bannerItemText,tag, artistName, title, labelName, description, tagLink } = item;
                const imagePath = `${process.env?.REACT_APP_BANNER_IMAGES}${imageUrl}`;
                return (
                  <SwiperSlide key={index} className={`homepage-carousel homepage-carousel-${index}`}>
                    <style>
                {`
                .homepage-carousel-${index}{
                  background-image: url('${imagePath}');
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                  height: 100vh; /* Adjust the height of the slide */
                }
                `}
              </style>
                    <CarouselItems
                      image={`${imagePath}`}
                      topButtton={tag || Localize.TagNotAvailable}
                      mainHeading={artistName || Localize.ArtistNotAvailable}
                      subHeading={title || Localize.TitleNotAvailable}
                      subHeading1={labelName || Localize.LabelNotAvailable}
                      tagline={description || Localize.DescriptionNotAvailable}
                      bottomButton={bannerItemText ? bannerItemText : `See release`}
                      Link={tagLink}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            )}
          </div>
          <Content className="releases">
            {bannerMarqueData && (
              <ReleasesHeading bannerData={bannerMarqueData} />
            )}
            <div className="container">
              <List
                className="main-releases-listing"
                dataSource={ProductsData && ProductsData.length > 0 ? ProductsData : []}
                locale={{ emptyText: <NoRecordFound /> }}
                renderItem={(item: any) => {
                  // console.log("item data ===", item)
                  return (
                    <List.Item>
                      <Releases
                        image={imageUrl(item?.productType?.name, item?.catNo)}
                        artistName={
                          item?.artists?.name || Localize.ArtistNotAvailable
                        }
                        title={item?.title || Localize.TitleNotAvailable}
                        desc={
                          item?.shortDescription ||
                          Localize.DescriptionNotAvailable
                        }
                        forthComing={item.isForthcoming || false}
                        isRsdSpecial={item.isRsdSpecial || false}
                        labelName={
                          item?.secondary_labelname ||
                          item?.labels?.name ||
                          Localize.LabelNotAvailable
                        }
                        productId={item?.id}
                        catNo={item?.catNo}
                        productType={item?.productType?.name}
                      />
                    </List.Item>
                  );
                }}
              />
              <Link
                className="ant-btn ant-btn-circle rounded-btn releases-btn"
                to="/releases"
              >
                <span>
                  {Localize.ReleaseButtonText}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25.625"
                    height="17.623"
                    viewBox="0 0 25.625 17.623"
                  >
                    <g
                      id="Group_418"
                      data-name="Group 418"
                      transform="translate(6855.444 -343.358) rotate(180)"
                    >
                      <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                        transform="translate(0.001 0)"
                        fill="none"
                        stroke="#141414"
                        stroke-width="1"
                      />
                      <line
                        id="Line_7"
                        data-name="Line 7"
                        x2="24.5"
                        transform="translate(6830.944 -352.426)"
                        fill="none"
                        stroke="#141414"
                        stroke-width="1"
                      />
                    </g>
                  </svg>
                </span>
              </Link>
            </div>
          </Content>
          <OurServicesTop />
          <OurServices ourServices={ourServicesLabels} />
        </div>
      )}
    </div>
  );
};

export default HomePage;
